// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"52becccc","830":"bc9f00be"}[chunkId] + ".chunk.js";
};